import { useState, useEffect } from "react";
import "../App.css";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Route, Routes, useLocation } from "react-router-dom";
import IndustriesScreen1 from "../flows/epos/industries-screen-1";
import DurationScreen2 from "../flows/epos/duration-screen-2";
import FeaturesScreen2 from "../flows/epos/features-screen-2";
import SitesScreen3 from "../flows/epos/sites-screen-3";
import DeliveryScreen4 from "../flows/epos/delivery-screen-4";
import ProductConfScreen5 from "../flows/epos/product-conf-screen-5";
import SupportScreen6 from "../flows/epos/support-screen-6";
import EstimationScreen7 from "../flows/epos/estimation-screen-7";
import ContactScreen8 from "../flows/epos/contact-screen-8";
import DevicesScreen1 from "../flows/epos/site-creation/devices-screen-1";
import TerminalsScreen2 from "../flows/epos/site-creation/terminal-screen-2";
import AccessoriesScreen3 from "../flows/epos/site-creation/accessories-screen-3";
import { ProgressBar } from "../components/progress-bar/progressBar";

const TOTAL_SCREENS: number = 8;

function EposRouter() {
  const location = useLocation();
  const [navigationPercentage, setNavigationPercentage] = useState<number>(0);

  useEffect(() => {
    switch (location.pathname) {
      case "/duration-screen-2":
      case "/features-screen-2":
        setNavigationPercentage(2 / TOTAL_SCREENS);
        break;
      case "/sites-screen-3":
      case "/devices-screen-1":
      case "/terminals-screen-2":
      case "/accessories-screen-3":
        setNavigationPercentage(3 / TOTAL_SCREENS);
        break;
      case "/delivery-screen-4":
        setNavigationPercentage(4 / TOTAL_SCREENS);
        break;
      case "/product-conf-screen-5":
        setNavigationPercentage(5 / TOTAL_SCREENS);
        break;
      case "/support-screen-6":
        setNavigationPercentage(6 / TOTAL_SCREENS);
        break;
      case "/estimation-screen-7":
        setNavigationPercentage(7 / TOTAL_SCREENS);
        break;
      case "/contact-screen-8":
        setNavigationPercentage(8 / TOTAL_SCREENS);
        break;
      default:
        setNavigationPercentage(0);
        break;
    }
    if (location.pathname !== "/") {
      const mainContainer = document.getElementById("main-app");
      if (mainContainer) mainContainer.scrollIntoView();
    }
  }, [location]);

  return (
    <div className="main-app-container" id="main-app">
      <ProgressBar
        percent={navigationPercentage}
        status={Math.trunc(navigationPercentage * 100) + "%"}
      />
      <div style={{ height: 30 }} />
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="slide" timeout={10000}>
          <Routes location={location}>
            <Route path={"/"} element={<IndustriesScreen1 />} />
            <Route path={"duration-screen-2"} element={<DurationScreen2 />} />
            <Route path={"features-screen-2"} element={<FeaturesScreen2 />} />
            <Route path={"sites-screen-3"} element={<SitesScreen3 />} />
            <Route path={"delivery-screen-4"} element={<DeliveryScreen4 />} />
            <Route
              path={"product-conf-screen-5"}
              element={<ProductConfScreen5 />}
            />
            <Route path={"support-screen-6"} element={<SupportScreen6 />} />
            <Route
              path={"estimation-screen-7"}
              element={<EstimationScreen7 />}
            />
            <Route path={"contact-screen-8"} element={<ContactScreen8 />} />
            <Route path={"devices-screen-1"} element={<DevicesScreen1 />} />
            <Route path={"terminals-screen-2"} element={<TerminalsScreen2 />} />
            <Route
              path={"accessories-screen-3"}
              element={<AccessoriesScreen3 />}
            />
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}

export default EposRouter;
